import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {Store} from "@ngrx/store";
import {
  fetchNotificationDetails,
  screenType
} from "../../core/shared.selectors";
import {
  NotificationItemModel
} from "../../../page-modules/notifications/model/notification-model";
import {Subject, takeUntil} from 'rxjs';
import {CommonService} from "../../services/common.service";

@Component({
  selector: 'app-notification-details-popup',
  templateUrl: './notification-details-popup.component.html',
  styleUrls: ['./notification-details-popup.component.css']
})
export class NotificationDetailsPopupComponent implements OnInit, OnDestroy {
  queryParamsActive: any
  notificationDetails: NotificationItemModel;
  loading: boolean = false;
  isScreenTypeDesktopOrTablet: boolean = false;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store,
    private commonService: CommonService
  ) {
    this.queryParamsActive = data.queryParams
  }

  ngOnInit(): void {
    this.store.select(fetchNotificationDetails).pipe(takeUntil(this.onDestroy))
      .subscribe((details: any) => {
        this.loading = details.loading
        this.notificationDetails = details.details
      });
    this.store.select(screenType).pipe(takeUntil(this.onDestroy))
      .subscribe(screenType => {
        if (screenType === 'desktop' || screenType === 'tablet') {
          this.isScreenTypeDesktopOrTablet = true;

        } else {
          this.isScreenTypeDesktopOrTablet = false;
        }
      });
  }

  navigateToDetail() {
    if (this.notificationDetails?.data?.link) {
      if (this.notificationDetails?.data?.external) {
        this.commonService.openInNewTab(this.notificationDetails?.data?.link)
      } else {
        this.commonService.openInCurrentTab(this.notificationDetails?.data?.link)
      }
    }
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
